import { createContext, useContext } from "react";

import type { Me } from "@/types/auth";

/**
 * Contexto de autenticação e o hook que o lê. O `<AuthProvider>` mora em `AuthContext.tsx`.
 *
 * Fica fora do arquivo do componente de propósito: o Fast Refresh do Vite só preserva o estado
 * ao editar um arquivo que exporta APENAS componentes. Hook e componente juntos forçavam
 * recarga completa da página a cada edição (aviso react-refresh/only-export-components).
 */
export interface AuthContextValue {
  /** `null` enquanto carrega ou quando não há sessão válida. */
  me: Me | null;
  isLoading: boolean;
  isAuthenticated: boolean;
  /**
   * `true` quando o usuário pode ver telas/ações de organizador — ou seja,
   * quando NÃO é `role === "operacional" && !is_super`. Ver `useIsOrg`
   * (`features/rbac`) para o hook público; isto aqui é o dado bruto.
   */
  isOrg: boolean;
  refetchMe: () => void;
}

export const AuthContext = createContext<AuthContextValue | null>(null);

export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error("useAuth precisa ser usado dentro de <AuthProvider>.");
  }
  return ctx;
}
